import { useEffect } from 'react';

const usePageTitle = (title) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title ? `${title} - Scalepunk ERP` : 'Scalepunk ERP';

    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};

export default usePageTitle;
